import React, { useRef, useEffect } from "react";
import {
  FormTab,
  TextInput,
  required,
  Record,
  TabbedForm,
  SelectInput,
  BooleanInput,
} from "react-admin";
import { useAppData } from "../../../common/hooks/useAppData";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface EldFormProps {
  record?: Record;
}

export const EldForm = (props: EldFormProps) => {
  const assignedTenantRef = useRef<string>();
  useEffect(() => {
    if (!props.record) {
      return;
    }

    if (props.record?.assignedToTenant) {
      assignedTenantRef.current = props.record.assignedToTenant;
    }

    if (assignedTenantRef.current) {
      props.record.assignedToTenant = assignedTenantRef.current;
    }
  }, [props.record]);

  const tenants = useAppData((x) => x.tenants) ?? [];

  return (
    <TabbedForm className="form-create-edit" variant="outlined" {...props}>
      <FormTab label="resources.master-elds.labels.generalInformation">
        <TextInput
          source="serialNumber"
          label="resources.master-elds.labels.serialNumber"
          validate={required()}
        />
        <TextInput
          source="vendor"
          label="resources.master-elds.labels.vendor"
          validate={required()}
        />
        <ProtectedElement source="assignedToTenantId">
          <SelectInput
            source="assignedToTenantId"
            label="resources.master-elds.labels.assignedToTenantId"
            choices={tenants}
            allowEmpty
            emptyText="resources.master-elds.labels.noTenant"
          />
        </ProtectedElement>
        <ProtectedElement source="debuggingEnabled">
          <BooleanInput source="debuggingEnabled" />
        </ProtectedElement>
        <ProtectedElement source="dataPlanEnabled">
          <BooleanInput source="dataPlanEnabled" defaultValue={true} />
        </ProtectedElement>
        <ProtectedElement source="note" label="Notes">
          <TextInput source="note" multiline />
        </ProtectedElement>
      </FormTab>
    </TabbedForm>
  );
};
